/**
 * Call outcomes for the lead list — mirrors services/leads/calls.py. The
 * server has the last word (it refuses a "Revin" without a date); this is
 * what lets the form ask for the date before anyone presses Save.
 */

export const CALL_OUTCOMES = [
  { id: "no_answer", label: "Nu răspunde", cls: "bg-[#EDEEF0] text-[#373A45]", date: "proposed" },
  { id: "call_back", label: "Revin", cls: "bg-[#3F8EBA]/15 text-[#1f5d80]", date: "required" },
  { id: "interested", label: "Interesat", cls: "bg-[#519872]/15 text-[#2f6b50]", date: "optional" },
  { id: "not_interested", label: "Nu e interesat", cls: "bg-[#FDECEC] text-[#9b1f2c]", date: "none" },
  { id: "wrong_number", label: "Număr greșit", cls: "bg-[#FDBA74]/30 text-[#92400E]", date: "none" },
];

export const OUTCOME_BY_ID = Object.fromEntries(CALL_OUTCOMES.map((o) => [o.id, o]));

/** "YYYY-MM-DD" in Romania, which is what the server compares against. */
export function todayRo(now = new Date()) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Bucharest" }).format(now);
}

export function addDays(iso, n) {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + n);
  const p = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** The date to prefill when an outcome is picked, or "" for none. */
export function proposedNextCall(outcomeId, today = todayRo()) {
  return OUTCOME_BY_ID[outcomeId]?.date === "proposed" ? addDays(today, 1) : "";
}

/** Why the call cannot be saved yet, or "" when it can. */
export function callProblem(outcomeId, nextDate, today = todayRo()) {
  const o = OUTCOME_BY_ID[outcomeId];
  if (!o) return "Alege rezultatul apelului.";
  if (o.date === "required" && !nextDate) return "Alege când revii cu apelul.";
  if (o.date !== "none" && nextDate && nextDate < today) return "Data următorului apel e în trecut.";
  return "";
}

/** "azi", "mâine", "peste 3 zile", "întârziat 2 zile" — for the next-call hint. */
export function nextCallLabel(iso, today = todayRo()) {
  if (!iso) return "";
  const days = Math.round((new Date(`${iso}T12:00:00`) - new Date(`${today}T12:00:00`)) / 86400000);
  if (days === 0) return "azi";
  if (days === 1) return "mâine";
  if (days > 1) return `peste ${days} zile`;
  return days === -1 ? "întârziat o zi" : `întârziat ${-days} zile`;
}
